// @flow

import axios from 'axios';
import { getBaseUrl } from '../../config/config';

export default function getTopEarlyFinishedActivities(projectId: string, startDate: string): Promise<Object> {
  return axios.get(`${getBaseUrl()}projects/${projectId}/insights/earliest_finished_activities${startDate ? `?start_date=${startDate}` : ''}`);
}
